import { CampaignCoupons } from '@/affiliate-dashboard/components/home/campaign-coupons/campaign-coupons';
import { Coupons } from '@/affiliate-dashboard/components/home/coupons/coupons';
import { Overview } from '@/affiliate-dashboard/components/home/overview';
import { EmailVerification } from '@/affiliate-dashboard/components/home/verify-email';
import { useCurrentUser } from '@/affiliate-dashboard/context/current-user-context';
import { PageWrapper } from '@/components/base/page-wrapper';
import { ScreenContainer } from '@/components/base/screen-container';
import { usePageLayout } from '@/context/layout-context';
import { cn } from '@/utils';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/(authenticated)/dashboard/_layout/home')(
  {
    component: () => (
      <PageWrapper title="Dashboard - Monevis">
        <HomePage />
      </PageWrapper>
    ),
  },
);

function HomePage(): JSX.Element {
  const { t } = useTranslation();
  usePageLayout({ title: t('homePage.title') });
  const data = useCurrentUser();

  return (
    <ScreenContainer className="gap-10">
      {!data.me.emailVerifiedAt && <EmailVerification email={data.me.email} />}
      <div
        className={cn('flex flex-col gap-10', {
          'pointer-events-none opacity-30 blur-sm': !data.me.emailVerifiedAt,
        })}
      >
        <CampaignCoupons />
        <Coupons />
        <Overview />
      </div>
    </ScreenContainer>
  );
}

export default HomePage;
